import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { CREATE_DMX_UNIVERSE } from './actionTypes';
import { createDmxUniverseSuccessful, createDmxUniverseFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* createUniverse({ payload: { universe } }) {
  try {
    const response = yield call(
      dmxAPI.createUniverse,
      universe.token,
      universe.controller_id,
      universe,
    );
    if (response.message) {
      yield put(createDmxUniverseSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createDmxUniverseFailed(error));
  }
}

export function* watchCreateDmxUniverse() {
  yield takeEvery(CREATE_DMX_UNIVERSE, createUniverse);
}

function* createDmxUniverseSaga() {
  yield all([fork(watchCreateDmxUniverse)]);
}

export default createDmxUniverseSaga;
